/**
 * Set a filter value on a URLSearchParams, or delete it when the value is empty,
 * the selects' "all" sentinel, or equal to the provided default. Dropping defaults
 * keeps shared / deep-linked URLs clean.
 *
 * Mutates `params` in place — intended for use inside a functional
 * `setSearchParams((prev) => ...)` updater so params owned by other components
 * (e.g. tab, date) are preserved.
 */
export const setOrDeleteParam = (
  params: URLSearchParams,
  key: string,
  value: string,
  defaultValue = "",
): void => {
  if (!value || value === "all" || value === defaultValue) {
    params.delete(key)
  } else {
    params.set(key, value)
  }
}
